/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef, useState } from 'react';
import NotificationDropdown from '../components/header/NotificationDropdown';
import UserDropdown from '../components/header/UserDropdown';
import CompanyDropdown from '../components/header/CompanyDropdown';
import { Box } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import RecorderHeader from '../components/header/RecorderHeader';
const AppHeader = () => {
  const headerRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSticky(!entry.isIntersecting);
      },
      { threshold: [1], rootMargin: '-1px 0px 0px 0px' }
    );

    if (headerRef.current) {
      observer.observe(headerRef.current);
    }

    return () => {
      if (headerRef.current) {
        observer.unobserve(headerRef.current);
      }
    };
  }, []);

  return (
    <div ref={headerRef} className={`navbar-header ${isSticky ? 'is-sticky' : ''}`}>
      <div className="row align-items-center justify-content-between">
        <div className="col-auto">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ display: { xl: 'none', lg: 'none', md: 'none', sm: 'none', xs: 'block' } }}>
              <img src='/favicon.svg'></img>
            </Box>
            <button type="button" className="sidebar-mobile-toggle">
              <Box sx={{ display: { xl: 'block', lg: 'none', md: 'block', sm: 'block', xs: 'none' } }}>
                <span className="icon"><MenuIcon /></span>
              </Box>
              <Box sx={{ display: { xl: 'none', lg: 'none', md: 'none', sm: 'none', xs: 'block' }, marginLeft: '5px' }}>
                <img style={{ height: '29px' }} src='https://cdn-icons-png.flaticon.com/128/4543/4543046.png'></img>
              </Box>
            </button>
            <Box sx={{ display: { xl: 'block', lg: 'block', md: 'block', sm: 'block', xs: 'none' } }}>
              <span className="fw-bold text-black">Hi Miquella</span>, Here's your dashboard for today.
            </Box>
          </Box>
        </div>
        <Box className="col-auto">
          <div className="d-flex flex-wrap align-items-center gap-3">
            {/* <button
              type="button"
              data-theme-toggle=""
              className="w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
            />
             */}
             <RecorderHeader/>
            <NotificationDropdown />
            <CompanyDropdown />
            <UserDropdown />
          </div>
        </Box>
      </div>
    </div>
  );
};

export default AppHeader;
